import { HeaderMenus as HeaderMenusIT } from './header';
import { FooterMenu as FooterMenuIT, FooterCopyRightLinks as FooterCopyRightLinksIT } from './footer';
import { GlobalNavigationConfig } from '../../../entities';

export const ItalyConfig: GlobalNavigationConfig = {
  footerVariant: 'simple',
  headerVariant: 'simple',
  logoVariant: 'italy',
  menu: {
    copyright: FooterCopyRightLinksIT,
    footer: FooterMenuIT,
    header: HeaderMenusIT,
  },
};
